// This file is auto-generated during build
export const version: string = "17.0_2608";
